/**
 * Created by lenovo on 2017/2/13.
 */
import React, {
    Component,
    PropTypes
} from 'react';
var className = "dark";
var newCount = 1;
import userService from 'SERVICES/ella/userService'
import Tip from 'COMPONENT/tip'
import {language,pageOption} from 'UTIL/common'
import ZtreeInput from 'COMPONENT/form/ztreeInput'
export default class PagerIndex extends Component {
    constructor(props) {
        super(props);
        this.getNodeTree = this.getNodeTree.bind(this);
        this.addHoverDom = this.addHoverDom.bind(this);
        this.removeHoverDom = this.removeHoverDom.bind(this);
        this.showRemoveBtn = this.showRemoveBtn.bind(this);
        this.showRenameBtn = this.showRenameBtn.bind(this);
        this.beforeDrag = this.beforeDrag.bind(this);
        this.beforeEditName = this.beforeEditName.bind(this);
        this.beforeRemove = this.beforeRemove.bind(this);
        this.beforeRename = this.beforeRename.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onRename = this.onRename.bind(this);
        this.getTime = this.getTime.bind(this);
        this.onClick = this.onClick.bind(this);
        this.submit = this.submit.bind(this);
        this.state = {
            nodeList: [],
            yesOrNo: [],
            expandId : '',
        }
    }

    componentDidMount() {
        $("#id").attr('disabled',true)
        $("#parentId").attr('disabled',true)
        $("#level").attr('disabled',true)
        $("#subsystemId").attr('disabled',true)
        this.initTree();
    }

    initTree() {
        userService.getPaper().then(data => {
            const json = data.data;
            const nodeList = JSON.parse(json.nodeVos);
            this.getNodeTree(nodeList)
            this.setState({
                yesOrNo: json.yesOrNo,
                nodeList: nodeList,
            });
        })
    }

    getTime() {
        var now = new Date(),
            h = now.getHours(),
            m = now.getMinutes(),
            s = now.getSeconds(),
            ms = now.getMilliseconds();
        return (h + ":" + m + ":" + s + " " + ms);
    }

    getNodeTree(zNodes) {
        const setting = {
            view: {
                addHoverDom: this.addHoverDom,
                removeHoverDom: this.removeHoverDom,
                selectedMulti: false
            },
            edit: {
                enable: true,
                showRemoveBtn: this.showRemoveBtn,
                showRenameBtn: this.showRenameBtn,
            },
            data: {
                simpleData: {
                    enable: true
                }
            },
            callback: {
                beforeDrag: this.beforeDrag,
                beforeEditName: this.beforeEditName,
                beforeRemove: this.beforeRemove,
                beforeRename: this.beforeRename,
                onRemove: this.onRemove,
                onRename: this.onRename,
                onClick: this.onClick,
            }
        };
        $.fn.zTree.init($("#treeDemo"), setting, zNodes);
        var treeObj = $.fn.zTree.getZTreeObj("treeDemo");
        console.log(this.state.expandId);
        var treenode = treeObj.getNodeByParam("id", this.state.expandId, null);
        treeObj.expandNode(treenode, true, false);
        treeObj.selectNode(treenode);
    }

    onClick(event, treeId, treeNode) {
        console.log(treeNode)
        if (treeNode.pId == null) {
            $("#editOrAdd").addClass("hidden");
        } else {
            $("#editOrAdd").removeClass("hidden")
        }
        $('#editOrAddForm')[0].reset();
        const id = treeNode.id;
        if (id > 100000) {
            $("#parentId").val(treeNode.pId);
            $("#subsystemId").val(treeNode.subsystemId);
        } else {
            var data = {
                id: treeNode.id
            };
            data = JSON.stringify(data);
            userService.getPaperInfo({data}).then(data => {
                const json = data.data.pagepermission;
                $("#isMenu").val(json.isMenu);
                $("#number").val(json.number);
                $("#subsystemId").val(json.subsystemId);
                $("#url").val(json.url);
                $("#enName").val(json.enName);
                $("#parentId").val(json.parentId);
            })
        }
        $("#level").val(treeNode.level);
        $("#name").val(treeNode.name);

        $("#id").val(treeNode.id);
    }

    beforeDrag(treeId, treeNodes) {
        return false;
    }

    beforeEditName(treeId, treeNode) {
        const self = this;
        className = (className === "dark" ? "" : "dark");
        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        zTree.selectNode(treeNode);
        this.onClick(event, treeId, treeNode)
        return false;
    }

    beforeRemove(treeId, treeNode) {
        className = (className === "dark" ? "" : "dark");
        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        zTree.selectNode(treeNode);
        return confirm(language()['deleteNode']+"---" + treeNode.name + "?");
    }

    onRemove(e, treeId, treeNode) {
        let pId = treeNode.pId;
        if (treeNode.id < 100000) {
            userService.deletePaperInfo(treeNode.id).then(data => {
                if (data.code == 8001) {
                    $("#editOrAdd").addClass("hidden");
                    $("#success_msg").text(data.msg);
                    $("#success_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                } else {
                    $("#error_msg").text(data.msg);
                    $("#error_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                }
            })
        }
        return ;
    }

    beforeRename(treeId, treeNode, newName, isCancel) {
        className = (className === "dark" ? "" : "dark");
        if (newName.length == 0) {
            setTimeout(function () {
                var zTree = $.fn.zTree.getZTreeObj("treeDemo");
                zTree.cancelEditName();
                alert(language()['nodeNotEmpty']+'!');
            }, 0);
            return false;
        }
        return true;
    }

    onRename(e, treeId, treeNode, isCancel) {
        return;
    }

    showRemoveBtn(treeId, treeNode) {
        return !(treeNode.pId == null);
    }

    showRenameBtn(treeId, treeNode) {
        return !(treeNode.pId == null);
    }

    addHoverDom(treeId, treeNode) {
        var sObj = $("#" + treeNode.tId + "_span");
        if (treeNode.editNameFlag || $("#addBtn_" + treeNode.tId).length > 0) return;
        var addStr = "<span class='button add' id='addBtn_" + treeNode.tId + "' title='add node' onfocus='this.blur();'></span>";
        sObj.after(addStr);
        var btn = $("#addBtn_" + treeNode.tId);
        if (btn) btn.bind("click", function () {
            var zTree = $.fn.zTree.getZTreeObj("treeDemo");
            console.log(treeNode)
            zTree.addNodes(treeNode, {
                id: 100000 + newCount,
                pId: treeNode.id,
                name: "new node" + (newCount++),
                subsystemId:treeNode.subsystemId,
            });
            return false;
        });
    };

    removeHoverDom(treeId, treeNode) {
        $("#addBtn_" + treeNode.tId).unbind().remove();
    };

    submit(event) {
        event.preventDefault();
        var flag = $("#id").val() > 100000?'add':'edit';
        var arr_1 = {
            name: $.trim($("#name").val()),
            parentId: $.trim($("#parentId").val()),
            isMenu: $.trim($("#isMenu").val()),
            level: $.trim($("#level").val()),
            number: $.trim($("#number").val()),
            enName: $.trim($("#enName").val()),
            subsystemId: $.trim($("#subsystemId ").val()),
            url: $.trim($("#url").val()),
        };
        var arr_2 = {
            id:  $("#id").val(),
            name: $.trim($("#name").val()),
            parentId: $.trim($("#parentId").val()),
            isMenu: $.trim($("#isMenu").val()),
            level: $.trim($("#level").val()),
            number: $.trim($("#number").val()),
            enName: $.trim($("#enName").val()),
            subsystemId: $.trim($("#subsystemId ").val()),
            url: $.trim($("#url").val()),
        }
        var  data = $("#id").val() > 100000?JSON.stringify(arr_1):JSON.stringify(arr_2);
        console.log(data)
        userService.saveOrUpdate({data}).then(data=>{
            console.log(data)
            if (data.code == 8001) {
                if(flag == 'add'){
                    $("#id").val(data.data);
                }
                this.setState({
                    expandId:flag== 'add'?data.data:arr_2.id,
                },()=>{
                    this.initTree();
                    this.getNodeTree();
                    $("#success_msg").text(data.msg);
                    $("#success_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 2000);
                    $("#success_tip").focus();
                })

            } else {
                $("#error_msg").text(data.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function () {
                    $("#error_tip").addClass("hidden");
                }, 2000)
                $("#error_tip").focus();
            }
        })
    }

    render() {
        const isMenuList = this.state.yesOrNo.map(function (str, index) {
            return <option value={index} key={index}>{str}</option>
        })
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['PermissionManagement']}
                        <small>{language()['CreatePermissions']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['CreateModel']}</h3>

                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className=" col-sm-4">
                                <input type="hidden" id="nodes"/>
                                <ul id="treeDemo" className="ztree" style={{width: "260px"}}></ul>
                            </div>
                            <div className="col-sm-8 hidden" id="editOrAdd">
                                <form id="editOrAddForm" className="form-horizontal">
                                    {/********所属子系统*************/}
                                    <ZtreeInput id="subsystemId" name="subsystem"/>
                                    {/********级别*************/}
                                    <ZtreeInput id="level" name="level"/>
                                    {/********父类ID*************/}
                                    <ZtreeInput id="parentId" name="parentId"/>
                                    {/********ID*************/}
                                    <ZtreeInput id="id" name="ID"/>
                                    {/********是否为菜单*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['isMenu']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="isMenu" name="isMenu" className="form-control col-sm-4">
                                                    {isMenuList}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/********权限名称*************/}
                                    <ZtreeInput id="number" name="AccessNumber"/>
                                    {/********权限名称*************/}
                                    <ZtreeInput id="name" name="PermissionName"/>
                                    {/********英文名*************/}
                                    <ZtreeInput id="enName" name="enName"/>
                                    {/********访问路径*************/}
                                    <ZtreeInput id="url" name="AccessPath"/>
                                </form>
                                <div className="panel-body"></div>
                                <div className="col-sm-10 col-md-offset-1">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-3 text-center">
                                        <button id="btnSubmit" className="btn btn-success" onClick={this.submit}>{language()['submit']}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/permission/pager/pageper.js